<section>
  <app-auth-template
    [title]="title()"
    [description]="desciption()"
  >
    @if (showForm) {
      <form>
        <app-input
          type="password"
          [control]="form.controls.password"
          [label]="'Passwort'"
        />
        <app-input
          type="password"
          [control]="form.controls.confirmPassword"
          [label]="'Passwort wiederholen'"
        />
      </form>

      <app-auth-button
        [disabled]="form.invalid || form.disabled"
        [isLoading]="requestState() === RequestStateEnum.PENDING"
        buttonText="Passwort speichern"
        (clicked)="setPassword()"
      />
    } @else {
      <app-auth-button
        [showHint]="true"
        buttonText="Zum Login"
        (clicked)="goToLogin()"
      />
    }
  </app-auth-template>
</section>
